(function () {
    const $doc = $(document);

    // 商品詳細
    $doc.on('click', '.Pdt_tab .Tab_lists .Tab_item', onClickProductProductCategoryTabItem);
    $doc.on('click', '.Gallery .ItemGallery_thumb', onClickGalleryItemThumbnail);
    $doc.on('click', '.-cartAdd', onClickAddCart);

    initPrtcPageProductDetail();
})();


/**
 * 商品詳細ページ初期化処理
 */
function initPrtcPageProductDetail() {

}



/**
 * 商品詳細ページ　商品カテゴリ選択タブクリック時処理
 */
function onClickProductProductCategoryTabItem() {
    const filter = $(this).find('input[type="radio"]').data('filter');

    const $targetRadioBtn = $(this).closest('.Pdt_sectionBody').find('.Pdt_options').find('[data-filter]');

    $targetRadioBtn.each(function (idx, val) {
        if ($(val).data('filter') == filter) {
            $(val).closest('.Option').show();
        } else {
            $(val).closest('.Option').hide();
        }
    });
}


/**
 * 商品詳細ページ　商品ギャラリーのサムネイルクリック時処理
 */
function onClickGalleryItemThumbnail() {

    const $itemGallery = $(this).closest('.ItemGallery');
    const category = $itemGallery.find('.prtc_item_gallery_category').text();
    const name = $itemGallery.find('.prtc_item_gallery_name').text();

    const $galleryLargeInner = $('.Gallery .Gallery_largeInner');
    $galleryLargeInner.find('.prtc_item_gallery_category_target').text(category);
    $galleryLargeInner.find('.prtc_item_gallery_name_target').text(name);
}


/**
 * 商品詳細ページ　カートボタン
 */
function onClickAddCart() {
    var container = $(this).closest('.-cartAdd');
    container.find('.cart_icon_inner').hide();
    container.find('.loading_product').show();
    var vid = $(this).data('vid');
    var width = $(this).data('width');
    var height = $(this).data('height');
    var length = $(this).data('length');

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: [
                {
                    quantity: 1,
                    id: vid,
                     properties: {
                        '_ms_width': width,
                        '_ms_height': height,
                        '_ms_length': length
                     }
                }
            ]
        },
        dataType: 'json',
        success: function () {
            console.log("add.js 読み込み成功");
            $('.Header_cart .CartIcon').click();
            addToCartOk();
        },
        error: function () {
            console.log("add.js 読み込み失敗")
        }
    });

    return false;

    function addToCartOk() {
        // カートのアイテム数と各カートに入れるボタンを更新する
        jQuery.get(document.URL).done(function (data, textStatus, jqXHR) {
            const doc = new DOMParser().parseFromString(data, 'text/html');

            // カートのアイテム数を更新
            jQuery('.CartIcon_num').html(doc.querySelector('.CartIcon_num').innerHTML);

            // 各カートに入れるボタンを更新
            jQuery('.prtc_product_option_right_box').each(function () {
                const currentBox = jQuery(this);
                const newContent = doc.querySelector('.prtc_product_option_right_box[data-variant="' + currentBox.data('variant') + '"]').innerHTML;

                currentBox.html(newContent);
            });

            const cartNum = parseInt(jQuery('.CartIcon_num').text());
            if (cartNum === 0) {
                jQuery('.CartIcon_num').hide();
            } else {
                jQuery('.CartIcon_num').css('display', 'flex');
            }
        });
    }
}

function onClickMinusCart(buttonElement) {
    var vid = $(buttonElement).data('vid');
    var quantityInput = $(buttonElement).siblings('.quantity__input');
    var currentQuantity = parseInt(quantityInput.val(), 10);
    var orderLimit = $(buttonElement).data('limit');
    var productTitle = $(buttonElement).data('title');

    var newQuantity = currentQuantity - 1;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            quantity: newQuantity,
            id: vid,
        },
        dataType: 'json',
        success: function () {
            console.log("カート数量-1");
            addToCartOk();
        },
        error: function () {
            console.log("カートの数量の変更に失敗しました");
        }
    });

    // 数量入力フィールドの値を更新
    quantityInput.val(newQuantity);

    //購入制限モーダル
    if (newQuantity > orderLimit && orderLimit !== '') {
        var limitProductTitleElement = document.querySelector('.limit-product-ttl');
        var limitProductElement = document.querySelector('.limit-product');
        var $body = $('body');
        var scrollTop;
            scrollTop = $(window).scrollTop();

            $body.css({
                position: 'fixed',
                top: -scrollTop,
            });

        limitProductTitleElement.textContent = productTitle;
        limitProductElement.textContent = orderLimit;

        document.querySelector('.limit_modal').style.display = 'block';
    }

    function addToCartOk() {
        jQuery.get(document.URL).done(function (data, textStatus, jqXHR) {
            const doc = new DOMParser().parseFromString(data, 'text/html');

            jQuery('.CartIcon_num').html(doc.querySelector('.CartIcon_num').innerHTML);

            jQuery('.prtc_product_option_right_box').each(function () {
                const currentBox = jQuery(this);
                const newContent = doc.querySelector('.prtc_product_option_right_box[data-variant="' + currentBox.data('variant') + '"]').innerHTML;

                currentBox.html(newContent);
            });

            const cartNum = parseInt(jQuery('.CartIcon_num').text());
            if (cartNum === 0) {
                jQuery('.CartIcon_num').hide();
            } else {
                jQuery('.CartIcon_num').css('display', 'flex');
            }
        });
    }
}

function onClickPlusCart(buttonElement) {
    var vid = $(buttonElement).data('vid');
    var quantityInput = $(buttonElement).siblings('.quantity__input');
    var currentQuantity = parseInt(quantityInput.val(), 10);
    var orderLimit = $(buttonElement).data('limit');
    var productTitle = $(buttonElement).data('title');

    var newQuantity = currentQuantity + 1;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            quantity: newQuantity,
            id: vid,
        },
        dataType: 'json',
        success: function () {
            console.log("カート数量+1");
            addToCartOk();
        },
        error: function () {
            console.log("カートの数量の変更に失敗しました");
        }
    });

    // 数量入力フィールドの値を更新
    quantityInput.val(newQuantity);

    //購入制限モーダル
    if (newQuantity > orderLimit && orderLimit !== '') {
        var limitProductTitleElement = document.querySelector('.limit-product-ttl');
        var limitProductElement = document.querySelector('.limit-product');

        limitProductTitleElement.textContent = productTitle;
        limitProductElement.textContent = orderLimit;

        document.querySelector('.limit_modal').style.display = 'block';
    }

    function addToCartOk() {
        jQuery.get(document.URL).done(function (data, textStatus, jqXHR) {
            const doc = new DOMParser().parseFromString(data, 'text/html');

            jQuery('.CartIcon_num').html(doc.querySelector('.CartIcon_num').innerHTML);

            jQuery('.prtc_product_option_right_box').each(function () {
                const currentBox = jQuery(this);
                const newContent = doc.querySelector('.prtc_product_option_right_box[data-variant="' + currentBox.data('variant') + '"]').innerHTML;

                currentBox.html(newContent);
            });

            const cartNum = parseInt(jQuery('.CartIcon_num').text());
            if (cartNum === 0) {
                jQuery('.CartIcon_num').hide();
            } else {
                jQuery('.CartIcon_num').css('display', 'flex');
            }
        });
    }
}

//detailsをふわっと開閉
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("details").forEach(function (el) {
        const summary = el.querySelector("summary");
        const answer = el.querySelector(".details_inner");
        summary.addEventListener("click", (event) => {
            event.preventDefault();
            if (el.getAttribute("open") !== null) {
                const closingAnim = answer.animate(closingAnimation(answer), animTiming);

                closingAnim.onfinish = () => {
                    el.removeAttribute("open");
                };
            } else {
                el.setAttribute("open", "true");
                const openingAnim = answer.animate(openingAnimation(answer), animTiming);
            }
        });
    });
});

const animTiming = {
    duration: 300,
    easing: "ease",
};

const closingAnimation = (answer) => [
    {
        height: answer.offsetHeight + "px",
        opacity: 1,
    },
    {
        height: 0,
        opacity: 0,
    },
];

const openingAnimation = (answer) => [
    {
        height: 0,
        opacity: 0,
    },
    {
        height: answer.offsetHeight + "px",
        opacity: 1,
    },
];